import React, { useEffect, useRef } from 'react';
import { AppBar, Container, Toolbar, useMediaQuery, Stack, Box } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';

const Header = () => {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const headerRef = useRef(null);

    const menuItems = [
        { title: 'Home', link: '/' },
        { title: 'ClearBox', link: '/#clearbox' },
        // { title: 'About Us', link: '/about' },
    ];

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

    useEffect(() => {
        const handleScroll = () => {
            if (headerRef.current) {
                if (window.scrollY > 100) {
                    headerRef.current.classList.add('scrolled');
                } else {
                    headerRef.current.classList.remove('scrolled');
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const DrawerList = (
        <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
            <List>
                {menuItems.map((menu, index) => (
                    <ListItem key={index} disablePadding>
                        <ListItemButton component={menu.link.startsWith('#') ? 'a' : Link} href={menu.link.startsWith('#') ? menu.link : undefined} to={menu.link.startsWith('#') ? undefined : menu.link}>
                            <ListItemText primary={menu.title} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    return (
        <>
            {isLargeScreen ? (
                <Stack
                    className='App-header'
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={0}
                    ref={headerRef}
                >
                    <Link to='/'><img className='header-logo' src={process.env.PUBLIC_URL + '/logos/ta_bg_less_light.svg'} alt="Tailored Alloys" style={{ cursor: 'pointer' }} /></Link>
                    <Stack direction={'row'} spacing={3} alignItems="center">
                        <Link to='/'>Home</Link>
                        <Link to='/#clearbox'>
                            <img src={process.env.PUBLIC_URL + '/static/images/ClearBox/clearbox.svg'} alt="ClearBox" height='25px' width='auto' />
                        </Link>
                        {/* <Link to='/about'>About Us</Link> */}
                        <a href="https://tailoredrings.com/" target="_blank" rel="noreferrer">
                            <div className='TR_header'>
                                <img src={process.env.PUBLIC_URL + '/tailoredringslogo.png'} alt="TailoredRingsLogo" height='20px' width='auto' />
                            </div>
                        </a>
                    </Stack>
                </Stack>
            ) : (
                <AppBar position="sticky" sx={{ marginTop: '-5px', backgroundColor: '#f8fbfe', color: 'black' }} ref={headerRef}>
                    <Container maxWidth="xl">
                        <Toolbar disableGutters>
                            <IconButton onClick={toggleDrawer(true)} edge="start" color="inherit" aria-label="menu">
                                <MenuIcon />
                            </IconButton>
                            <Drawer open={open} onClose={toggleDrawer(false)}>
                                {DrawerList}
                            </Drawer>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    textAlign: 'center',
                                    alignItems: "center",
                                    margin: '5px 0 5px 0',
                                }}
                            >
                                <Link to='/'>
                                    <img className='header-logo' src={process.env.PUBLIC_URL + '/logos/ta_bg_less_light.svg'} alt="TailoredAlloysLogo" style={{ cursor: 'pointer', height: '40px', width: 'auto' }} />
                                </Link>
                            </Box>
                            <a href="https://tailoredrings.com/" target="_blank" rel="noreferrer">
                                <div className='TR_header'>
                                    <img src={process.env.PUBLIC_URL + '/tailoredringslogo.png'} alt="TailoredRingsLogo" height='20px' width='auto' />
                                </div>
                            </a>
                        </Toolbar>
                    </Container>
                </AppBar>
            )}
        </>
    );
};

export default Header;